import React, { useEffect, useContext, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext/AuthProvider";
import { ToastContainer, toast } from "react-toastify";

const Login = () => {
  const [userIP, setUserIP] = useState('')
  const getIP = async () => {
    const res = await fetch("https://api.ipify.org");
    const data = await res.text();
    setUserIP(data);
  };

  useEffect(() => {
    getIP();
  }, []);
  const { setAuthCredential } = useContext(AuthContext);
  const refAdminLoginSubmitDis = useRef();
  const refAdminLoginShowRef = useRef();
  const refTwoFactorVerifyShowRef = useRef();

  const [AdminData, setAdminData] = useState({});
  const [errorMessage, setErrorMessage] = useState([]);

  const handleAdminLogin = (event) => {
    event.preventDefault();
    try {

      refAdminLoginSubmitDis.current.setAttribute("disabled", true);
      const formData = new FormData(event.currentTarget);
      const InpuData = Object.fromEntries(formData);
      fetch("https://api.velormall.com/api/admin/auth/login", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(InpuData),
      })
        .then((res) => res.json())
        .then((data) => {

          if (data.success === false) {
            if (data?.message) {
              toast.error(`${data.message}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
            setErrorMessage(data?.errors)
            refAdminLoginSubmitDis.current.removeAttribute("disabled");
          } else {
            toast.success(`${data.message}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            refAdminLoginShowRef.current.style.display = "none";
            refTwoFactorVerifyShowRef.current.style.display = "block";
            setAdminData(data);
          }
        })
        .catch((error) => console.log(error));

    } catch (error) {
      console.log(error)
    }
  };

  const navigate = useNavigate();
  const location = useLocation();
  const AdminFrom = location.state?.from?.pathname || "/admin/dashboard";
  const AgentFrom = location.state?.from?.pathname || "/agent/dashboard";



  const refTwoFactorSubmitDis = useRef();
  const [errorMessageTwoFactorVerify, setErrorMessageTwoFactorVerify] = useState([]);

  const handleTwoFactorVerify = (event) => {
    event.preventDefault();
    try {
      refTwoFactorSubmitDis.current.setAttribute("disabled", true);
      const formData = new FormData(event.currentTarget);
      const InpuData = Object.fromEntries(formData);
      const VerifySendData = {
        ...InpuData,
        _id: AdminData?.data?._id,
        email: AdminData?.data?.email,
        userIP
      };
      fetch("https://api.velormall.com/api/admin/auth/two/factor/verify", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Beare ${AdminData?.token}`,
        },
        credentials: "include",
        body: JSON.stringify(VerifySendData),
      })
        .then((res) => res.json())
        .then((data) => {


          if (data.success === false) {

            setErrorMessageTwoFactorVerify(data?.errors);
            refTwoFactorSubmitDis.current.removeAttribute("disabled");
          } else {
            const user = data;

            const AuthData = {
              _id: user?.data?._id,
              name: user?.data?.name,
              deviceId: user?.data?.deviceId,

            }

            // console.log(user)
            localStorage.setItem("InfiniteMall_admin_ID", JSON.stringify(AuthData));
            event.target.reset();
            toast.success(`${data.message}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            if (user.data) {


              setAuthCredential({ adminData: AuthData, token: user?.token });

              if (user?.data?.role === "admin") {
                return navigate(AdminFrom, { replace: true });
              }

              if (user?.data?.role === "agent") {
                return navigate(AgentFrom, { replace: true });
              }

              // Unknown role
              return navigate("/unauthorized", { replace: true });

            }
          }
        })
        .catch((error) => console.log(error));
    } catch (error) {
    }
  };

  const refResendSubmitDis = useRef();

  const handleResendCode = (event) => {
    event.preventDefault();
    refResendSubmitDis.current.setAttribute("disabled", true);
    refTwoFactorSubmitDis.current.setAttribute("disabled", true);
    fetch("https://api.velormall.com/api/admin/auth/two/factor/code/resend", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ email: AdminData?.data?.email }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === false) {
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          refResendSubmitDis.current.removeAttribute("disabled");
          refTwoFactorSubmitDis.current.removeAttribute("disabled");
          setAdminData(data);
          toast.success(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div
        className="login-main"
      // style={{
      //   backgroundImage:
      //     "url('https://gffexvip.biz/assets/admin/images/login.jpg')",
      // }}
      >
        <div className="container custom-container">
          <div className="row justify-content-center">
            <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-8 col-sm-11">
              <div className="login-area">
                <div className="login-wrapper">
                  <div className="login-wrapper__top">
                    <h3 className="title text-white">
                      Welcome to <strong> VMall</strong>
                    </h3>
                    <p className="text-white">Admin Login to  VMall Dashboard</p>
                  </div>
                  <div className="login-wrapper__body">
                    <form
                      onSubmit={handleAdminLogin}
                      className="cmn-form mt-30 verify-gcaptcha login-form"
                      ref={refAdminLoginShowRef}
                    >
                      <div className="form-group">
                        <label htmlFor="username" className="required">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="username"
                        />
                        {errorMessage?.email && (
                          <span className="text-danger pt-2">
                            {errorMessage?.email?.msg}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="password" className="required">
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="password"
                          id="password"
                        />
                        {errorMessage?.password && (
                          <span className="text-danger pt-2">
                            {errorMessage?.password?.msg}
                          </span>
                        )}
                      </div>
                      <div className="d-flex flex-wrap justify-content-between">
                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            name="remember"
                            type="checkbox"
                            id="remember"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="remember"
                          >
                            Remember Me
                          </label>
                        </div>
                        <Link
                          to="/admin/password/reset"
                          className="forget-text"
                        >
                          Forgot Password?
                        </Link>
                      </div>
                      <button
                        ref={refAdminLoginSubmitDis}
                        type="submit"
                        className="login-btn cmn-btn w-100"
                      >
                        LOGIN
                      </button>
                    </form>
                    <div
                      style={{ display: "none" }}
                      ref={refTwoFactorVerifyShowRef}
                    >
                      <form
                        onSubmit={handleTwoFactorVerify}
                        className="cmn-form mt-30 verify-gcaptcha login-form"
                      >
                        <div className="form-group">
                          <label htmlFor="code" className="required">
                            Two Factor Code
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="code"
                            id="code"
                            min="0"
                          />
                          {errorMessageTwoFactorVerify?.code && (
                            <span className="text-danger pt-2">
                              {errorMessageTwoFactorVerify?.code?.msg}
                            </span>
                          )}
                        </div>

                        <button
                          ref={refTwoFactorSubmitDis}
                          type="submit"
                          className="login-btn cmn-btn w-100"
                        >
                          Verify
                        </button>
                      </form>
                      <form onSubmit={handleResendCode}>
                        <button
                          ref={refResendSubmitDis}
                          type="submit"
                          className="login-btn cmn-btn w-100"
                        >
                          Resend Code
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
